module.exports = __webpack_public_path__ + "img/cancel.a89da36d.svg";